export default "__VITE_ASSET__Q5uvOWAe__"